
namespace GeniuzPOS.InventoryReport {
    import fld = IcReport08Row.Fields;
    @Serenity.Decorators.registerClass()
    export class IcReport08Grid extends Serenity.EntityGrid<IcReport08Row, any> {
        protected getColumnsKey() { return IcReport08Columns.columnsKey; }
        protected getDialogType() { return IcReport08Dialog; }
        protected getIdProperty() { return IcReport08Row.idProperty; }
        protected getInsertPermission() { return IcReport08Row.insertPermission; }
        protected getLocalTextPrefix() { return IcReport08Row.localTextPrefix; }
        protected getService() { return IcReport08Service.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        private getFilterDescriptions(grid: Serenity.DataGrid<any, any>, gridColumns: Slick.Column[], options: GeniuzPOS.Common.Helpers.IcReportPdfOptions): any {
            // let request = Q.deepClone(grid.view.params) as Serenity.ListRequest;
            // let columns = Object.keys(options.columnStyles)

            let descriptions: string[] = [];

            var b1 = ""
            let b1n : string = QRreport.QRywcSpecRow.getLookup().itemById["55"].SkuCode;
            if (b1n != null) {
                let pos = Product.CsSkuRow.getLookup().itemById[b1n].SkuCode;
                b1 = " ระบุสินค้า:" + b1n + " " + pos

            } else {

                b1 

            }
            var b = ""
            let find : string = QRreport.QRywcSpecRow.getLookup().itemById["55"].CatCode;
            if (find != null) {
                let pos = Product.CsCategoryRow.getLookup().itemById[find].CatName;
                b = b1 + " ระบุหมวดสินค้า:" + find + " " + pos

            } else {

                b = b1

            }
            var c = ""
            let cf : string = QRreport.QRywcSpecRow.getLookup().itemById["55"].SubCat1Code;


            if (cf != null) {
                let cn = Product.CsSubCategory1Row.getLookup().itemById[cf].SubCat1Name;
                c = b + " ระบุหมวดสินค้า2:" + cf + " " + cn

            } else {

                c = b

            }

            var d = ""
            let df : string = QRreport.QRywcSpecRow.getLookup().itemById["55"].SubCat2Code;


            if (df != null) {
                let dn = Product.CsSubCategory2Row.getLookup().itemById[df].SubCat2Name;
                d = c + " ระบุหมวดสินค้า3:" + df + " " + dn

            } else {

                d = c

            }
            var e = ""
            let ef : string = QRreport.QRywcSpecRow.getLookup().itemById["55"].BrandCode;


            if (ef != null) {
                let en = Product.CsBrandRow.getLookup().itemById[ef].BrandName;
                e = d + " ระบุแบรนด์:" + en

            } else {

                e = d

            }
            var f = ""
            let ff : string = QRreport.QRywcSpecRow.getLookup().itemById["55"].StyleId;


            if (ff != null) {
                let fn = Product.CsStyleRow.getLookup().itemById[ff].StyleName;
                f = e + " ระบุแบบ:" + fn

            } else {

                f = e

            }

            var g = ""
            let gf : string = QRreport.QRywcSpecRow.getLookup().itemById["55"].ColorId;
            // let gn = Product.CsColorRow.getLookup().itemById[find].ColorName;

            if (gf != null) {

                g = f + " ระบุสี:" + gf

            } else {

                g = f

            }
            var h = ""
            let hf : string = QRreport.QRywcSpecRow.getLookup().itemById["55"].SizeId;
            // let hn = Product.CsColorRow.getLookup().itemById[find].ColorName;

            if (hf != null) {

                h = g + " ระบุขนาด:" + hf

            } else {

                h = g

            }
            var ii = ""
            let iif : string = QRreport.QRywcSpecRow.getLookup().itemById["55"].TasteId;
            // let hn = Product.CsColorRow.getLookup().itemById[find].ColorName;

            if (iif != null) {

                ii = h + " ระบุกลิ่น/รส:" + iif

            } else {

                ii = h

            }
            var j = ""
            let jf : string = QRreport.QRywcSpecRow.getLookup().itemById["55"].MatTypeId;
            // let hn = Product.CsColorRow.getLookup().itemById[find].ColorName;

            if (jf != null) {

                j = ii + " ระบุวัสดุ:" + jf

            } else {

                j = ii

            }
            var k = ""
            let kf : string = QRreport.QRywcSpecRow.getLookup().itemById["55"].SupplId;
            // let hn = Product.CsColorRow.getLookup().itemById[find].ColorName;

            if (kf != null) {

                k = j + " ระบุผู้จำหน่าย:" + kf

            } else {

                k = j

            }
            var l = ""
            let lf = QRreport.QRywcSpecRow.getLookup().itemById["55"].ConsignFg;
            // let hn = Product.CsColorRow.getLookup().itemById[find].ColorName;

            if (lf != null) {

                if (lf = 0) {
                    l = k + " สินค้าปกติเท่านั้น"
                } else {
                    l = k + " สินค้าฝากขายเท่านั้น"
                }

            } else {

                l = k

            }

            descriptions.push(l);
            return [descriptions, gridColumns];
        }
        // protected createQuickSearchInput() {
        // }

        

        protected usePager() {
            return false;
        }

        protected createToolbarExtensions() {
            super.createToolbarExtensions();

            this.slickGrid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());

            var groupingMixin = new Serenity.DraggableGroupingMixin({
                grid: this
            });

            // setting ShipCountry, ShipCity columns as initially grouped for this sample
            // you could add [GroupOrder(1)] to ShipCountry, and [GroupOrder(2)] to ShipCity
            // in OrderColumns.cs instead (recommended way)
            groupingMixin.plugin.setDroppedGroups(["SupplName"]);
        }
        protected markupReady() {
            super.markupReady();

            // expanding all level 0 (Country) and level 1 (City) groups initially
            this.view.expandAllGroups(0);
            // this.view.expandAllGroups(1);
            // this.view.expandAllGroups(2);

        }
        protected getButtons(): Serenity.ToolButton[] {
            var buttons = super.getButtons();
           
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            buttons.push(Common.Helpers.ExcelExportHelper.createToolButton({
                grid: this,
                service: IcReport08Service.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));

            let reportTitle = 'รายงานสินค้าคงเหลือ Serial number'

            // Max page width = 277
            let columnStyles: { [dataKey: string]: GeniuzPOS.Common.Helpers.AutoTableStyles } = {
                0: { field: "SkuCode", title: "รหัสสินค้า", cellWidth: 20, },
                1: { field: "SkuDesc", title: "ชื่อ", cellWidth: 65, overflow: 'linebreak' },
                // 2: { field: "WhsId", title: "คลัง", cellWidth: 10,  },
                // 3: { field: "WhsName", title: "ชื่อคลัง", cellWidth: 15  ,overflow: 'linebreak'},
                2: { field: "SkuEnDesc", title: "์Name", cellWidth: 65, overflow: 'linebreak' },
                3: { field: "QtyOnhand", title: "Qty", cellWidth: 15, overflow: 'linebreak' , halign: 'right'},
                // 6: { field: "ShopGroupId", title: "กลุ่มร้าน", isHidden: true},
                // 7: { field: "ShopId", title: "ร้านค้า", isHidden: true},                
                // 4: { field: "StkUnit", title: "หน่วย", cellWidth: 15, overflow: 'linebreak', halign: 'center' },
                4: { field: "Countt", title: "Count", cellWidth: 15, halign: 'right' },
                // 6: { field: "MaxStockQty", title: "Max", cellWidth: 20, halign: 'right' },

                5: { field: "BrandCode", title: "ยี่ห้อ", isHidden: true },
                6: { field: "StyleId", title: "แบบ", isHidden: true },
                7: { field: "SizeId", title: "ขนาด", isHidden: true },
                8: { field: "ColorId", title: "สี", isHidden: true },
                9: { field: "SupplId", title: "ผู้จำหน่าย", isHidden: true },
                10: { field: "SupplName", title: "ผู้จำหน่าย", cellWidth: 65},
                11: { field: "CatCode", title: "หมวดสินค้า", isHidden: true },
                12: { field: "CatName", title: "หมวดสินค้า", isHidden: true },
                13: { field: "SubCat1Code", title: "หมวดสินค้า-2", isHidden: true },
                14: { field: "SubCat1Name", title: "หมวดสินค้า-2", isHidden: true },
                15: { field: "SubCat2Code", title: "หมวดสินค้า-3", isHidden: true },
                16: { field: "SubCat2Name", title: "หมวดสินค้า-3", isHidden: true },
                17: { field: "TasteId", title: "กลิ่น/รส", isHidden: true },
                18: { field: "MatTypeId", title: "วัสดุที่ใช้", isHidden: true },
                19: { field: "ConsignFg", title: "สินค้าฝากขาย?", isHidden: true },
                // 20: { field: "PurLeadTime", title: "ระยะเวลาสินค้าเข้า", cellWidth: 20, halign: 'right' },

               
                

            }

            // buttons.push(GeniuzPOS.Common.Helpers.IcReportPdfHelper.createToolButton({
            //     grid: this,
            //     onViewSubmit: () => this.onViewSubmit(),
            //     reportTitle: reportTitle,
            //     separator: true,
            //     onCreateFilterDescriptions: (grid: Serenity.DataGrid<any, any>, gridColumns: Slick.Column[], options: GeniuzPOS.Common.Helpers.IcReportPdfOptions) => this.getFilterDescriptions(grid, gridColumns, options),

            //     pageNumbers: true,
            //     columnStyles: columnStyles,
            //     // groupHeader: {
            //     //     0: { title: 'หน่วย', startX: 125, width: 70 }
            //     // },
            //     hideGroupColumn: false,
            //     // pageSize:{width:210,height:297},
            //     theme: 'plain',
            //     showTableHead: 'everyPage',
            //     isCustomHeader: true,
            //     //reportTitle: "This is report title",
            //     titleTop: 7,
            //     titleFontSize: 12,
            //     fileName: "ThisIsTheFileName",
            //     //pageNumbers: true,
            //     columnTitles: {
            //         'OriginalColumn': 'OCol.',
            //     },
            //     tableOptions: {
            //         columnStyles: {
            //             OriginalColumn: {
            //                 // columnWidth: 25,
            //                 halign: 'right'
            //             }
            //         }
            //     }
            // }));

            // buttons.push(GeniuzPOS.Common.Helpers.IcReportPdfHelper.createToolButton({
            //     grid: this,
            //     onViewSubmit: () => this.onViewSubmit(),
            //     reportTitle: reportTitle,
            //     separator: true,
            //     onCreateFilterDescriptions: (grid: Serenity.DataGrid<any, any>, gridColumns: Slick.Column[], options: GeniuzPOS.Common.Helpers.IcReportPdfOptions) => this.getFilterDescriptions(grid, gridColumns, options),

            //     pageNumbers: true,
            //     autoPrint: true,
            //     output: "dataurlnewwindow",
            //     columnStyles: columnStyles,
            //     // groupHeader: {
            //     //     0: { title: 'หน่วย', startX: 125, width: 70 }
            //     // },
            //     hideGroupColumn: false,
            //     theme: 'plain',

            //     showTableHead: 'everyPage',
            //     isCustomHeader: true,

            //     //reportTitle: "This is report title",
            //     titleTop: 7,
            //     titleFontSize: 12,
            //     fileName: "ThisIsTheFileName",
            //     //pageNumbers: true,
            //     columnTitles: {
            //         'OriginalColumn': 'OCol.',
            //     },
            //     tableOptions: {
            //         columnStyles: {
            //             OriginalColumn: {
            //                 // columnWidth: 25,
            //                 halign: 'right'
            //             }
            //         }
            //     }
            // }));
            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/QRreport/QRywcSpec#QRreport.QRywcSpec_icrp01_8/edit/55';
                        return false;
                    },
                }
            );
            return buttons;
            
        }
    
        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            opt.groupingPanel = true;
            opt.showFooterRow = true;
            return opt;
        }

        protected createSlickGrid() {
            var grid = super.createSlickGrid();
           

            grid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());

            this.view.setSummaryOptions({
                aggregators: [
                    new Slick.Aggregators.Sum('QtyOnHand'),
                    new Slick.Aggregators.Sum('Countt')
                   
                ]
            });
            return grid;
        }
        protected getColumns() {
            var columns = super.getColumns();
    
            columns.splice(1, 0, {
                id: 'Print rowreport',
                field: null,
                name: '',
                cssClass: 'align-center',
                format: ctx => {
                    return '<a class="inline-action print-rowreport" title="countapprove">' +
                    '<i class="fa fa-file-pdf-o text-red"></i></a>';
                },
                width: 30,
                minWidth: 30,
                maxWidth: 30
            });
    
            return columns;
        }
    
        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);
    
            // if (e.isDefaultPrevented())
            //     return;
    
            var item = this.itemAt(row);
            var target = $(e.target);

            
            if (target.parent().hasClass('inline-action'))
                target = target.parent();
    
            if (target.hasClass('inline-action')) {
                e.preventDefault();
    
                if (target.hasClass('print-rowreport')) {
                    const request = this.getView().params as IcReport08HdDtReportData
                    request.SkuCode = item.SkuCode
                    Q.postToService({ service: this.getService() + '/ExportPdf', request: request, target: '_blank' })
                    
                    ;
                }
            }
        }
    }
}